var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4583,
    cy: 13.5417,
    r: 13.4583,
    fill: "#956D84"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6439 5.77852C10.6496 5.77852 7.8062 5.51747 6.72014 8.24916C6.27153 9.3774 6.33667 10.8427 6.33667 12.9407C6.33667 14.7818 6.27647 16.5121 6.72014 17.6315C7.80373 20.3648 10.6702 20.1029 13.6423 20.1029C16.5096 20.1029 19.466 20.3955 20.5652 17.6315C21.0147 16.4919 20.9487 15.0485 20.9487 12.9407C20.9487 10.1428 21.1062 8.33645 19.7216 6.9803C18.3197 5.60637 16.4238 5.77852 13.6406 5.77852H13.6439ZM13.4584 6.9354C19 6.9354 20.1875 6.54747 19.7917 15.8579C19.3959 18.9613 16.788 19.1251 13.6439 19.1251C8.13691 19.1251 7.36271 18.5734 7.2426 12.9407C7.10627 6.54747 9.1042 6.9354 13.4584 6.9354ZM17.5445 8.25805C17.0605 8.25805 16.6679 8.64275 16.6679 9.11716C16.6679 9.59157 17.0605 9.97627 17.5445 9.97627C18.0286 9.97627 18.4211 9.59157 18.4211 9.11716C18.4211 8.64275 18.0286 8.25805 17.5445 8.25805ZM13.6439 9.26264C11.5716 9.26264 9.89175 10.9097 9.89175 12.9407C9.89175 14.9717 11.5716 16.618 13.6439 16.618C15.7163 16.618 17.3953 14.9717 17.3953 12.9407C17.3953 10.9097 15.7163 9.26264 13.6439 9.26264ZM13.6439 10.5533C16.8642 10.5533 16.8683 15.3281 13.6439 15.3281C10.4245 15.3281 10.4195 10.5533 13.6439 10.5533Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst);
export default __webpack_public_path__ + "static/media/inst.acef0c74b2caf33622424bf1146ebb74.svg";
export { ForwardRef as ReactComponent };